export default function SkipBackwardIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='currentColor'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M19.4332 3.09871C19.7797 3.26523 20 3.6156 20 4.00001V20C20 20.3844 19.7797 20.7348 19.4332 20.9013C19.0867 21.0678 18.6755 21.021 18.3753 20.7809L8.3753 12.7809C8.13809 12.5911 8 12.3038 8 12C8 11.6962 8.13809 11.4089 8.3753 11.2191L18.3753 3.21914C18.6755 2.979 19.0867 2.93219 19.4332 3.09871ZM10.6008 12L18 17.9194V6.08063L10.6008 12Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M5 4C5.55228 4 6 4.44772 6 5V19C6 19.5523 5.55228 20 5 20C4.44772 20 4 19.5523 4 19V5C4 4.44772 4.44772 4 5 4Z'
        />
      </svg>
    </span>
  );
}
